/**
 * Shared formatting utilities for group management forms
 */

/**
 * Format percentage value for display
 * @param {number} value - The decimal value to format
 * @returns {string} - Formatted percentage string
 */
export const formatPercentage = (value) => {
  return `${(value * 100).toFixed(4)}%`;
};

/**
 * Format currency value for display
 * @param {number} value - The numeric value to format
 * @returns {string} - Formatted currency string
 */
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  }).format(value);
};

/**
 * Format leverage value for display
 * @param {number} value - The leverage value
 * @returns {string} - Formatted leverage string
 */
export const formatLeverage = (value) => {
  return `${value || 1}:1`;
};

/**
 * Parse numeric value from string, handling edge cases
 * @param {string} value - The string value to parse
 * @param {number} fallback - Fallback value if parsing fails
 * @returns {number} - Parsed numeric value
 */
export const parseNumericValue = (value, fallback = 0) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? fallback : parsed;
};

/**
 * Get display sections configuration
 * @returns {Array} - Array of section objects
 */
export const getFormSections = () => [
  { id: 'basic', label: 'Basic Info', icon: 'fas fa-info-circle' },
  { id: 'leverage', label: 'Leverage Settings', icon: 'fas fa-balance-scale' },
  { id: 'trading', label: 'Trading Parameters', icon: 'fas fa-chart-line' }
];